import { Component, Input } from '@angular/core';

@Component({
  selector: 'nns-icon',
  host: {
    "[class]": '_classes',
    '(mouseenter)': 'onMouseEnter()',
    '(mouseleave)': 'onMouseLeave()'
  },
  styles: [`
    :host {
      display: block;
      min-height: 24px;
      min-width: 24px;
    }
    :host-context(.no-flex) :host {
      display: block;
    }
  `],
  template: ``
})
export class IconComponent {
  @Input() public icon;
  @Input() public hoverIcon;
  public _classes;

  ngOnChanges() {
    if (this.icon) {
      this._classes = 'icon-' + this.icon;
    }
  }

  onMouseEnter() {
    if (this.hoverIcon) {
      this._classes = 'icon-' + this.hoverIcon;
    }
  }

  onMouseLeave() {
    if (this.hoverIcon) {
      this._classes = 'icon-' + this.icon;
    }
  }
}
